import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../Core/Store";
import cloneDeep from "lodash/cloneDeep";

interface DialogSliceState {
  shareVisible: boolean;
}

const defaultState: DialogSliceState = {
  shareVisible: false,
};

const getInitialState = (): DialogSliceState => {
  return cloneDeep(defaultState);
};

export const initialState: DialogSliceState = getInitialState();

const dialogSlice = createSlice({
  name: "dialog",
  initialState,
  reducers: {
    updateShareVisible: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        shareVisible: action.payload,
      };
    },
  },
  //extraReducers: (builder) => {
  //    builder.addCase(updateSelectedItem.fulfilled, (state, action: PayloadAction<any>) => {
  //        return {
  //            ...state,
  //            selectedItem : action.payload
  //        };
  //    });

  //},
});
export const { updateShareVisible } = dialogSlice.actions;
export const getDialogSelector = (state: RootState): DialogSliceState =>
  state.dialog;

export default dialogSlice.reducer;
